import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const TagContainer = styled.button`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  height: 30px;
  padding: 0 15px;
  margin-right: 15px;
  border-radius: 18px;
  background-color: ${ColorPalette.HEX.PineTree};
  cursor: pointer;

  @media ${({ theme }) => theme.device.desktop} {
    margin: 4px 15px 4px 0;
  }
`;

export const Content = styled.span`
  display: inline-block;
  white-space: nowrap;
  font-size: 12px;
  color: white;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  margin-right: 15px;
`;
